import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

import { AlertService, StudentService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';

import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

@Component({
    selector: 'app-des-student-list',
    templateUrl: './des-student-list.component.html',
    styleUrls: ['./des-student-list.component.css']
})
export class DesStudentListComponent implements OnInit {

    @ViewChild('overSwal') private overSwal: SwalComponent;
    @ViewChild('offSwal') private offSwal: SwalComponent;
    @ViewChild('noPracticalSwal') private noPracticalSwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    isError = false;
    loading = false;
    submitted = false;
    returnUrl: string;
    imagePath: string;
    over1: string;
    over2: string;
    over3: string;
    _over0: string
    _over1: string;
    _over2: string;
    errorMsg: string;
    students = [];
    localData = {};
    authenticationService: any;
    activeExam = {};
    viva_assessor: number
    viva_pc: number = 0;
    practical_viva: number = 0;
    allowExamType: number = 0;
    examid:number = 0;     

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private studentService: StudentService,
        private alertService: AlertService,
        private globals: Globals
    ) { }

    ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.activeExam = JSON.parse(localStorage.getItem('activeExam_PS'));
        this.imagePath = '/assets/images/pic-upload.png';
        this.over2 = '/assets/images/marks_update.png';
        this.over3 = '/assets/images/marks_updated.jpg';
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        this.viva_assessor = this.activeExam['viva_assessor'];
        this.viva_pc = this.activeExam['vivapc'];
        this.practical_viva = this.activeExam['viva_practical'];
        this.examid = this.activeExam['exam_id'];

        this.getStudentsData();
    }


    private getStudentsData() {
        this.submitted = true;
        this.studentService.descriptiveStudentlist(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.students = data.students;

                    } else if (data.code == 1001) {
                        this.isError = true;
                        this.noPracticalSwal.show();
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }


                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            );
    }


    public over(vc: number) {
        if (vc == 2) {
            this.overSwal.show();
            return;
        }
    }



    public gotoDashboard() {
        this.router.navigateByUrl('/home/' + this.examid+'/'+this.viva_assessor+'/'+this.viva_pc+'/'+this.practical_viva);
    }

    public reload() {
        window.location.reload();
    }

    public marksupdate(id: Number) {
        this.router.navigateByUrl('/des-marks/' + id);
    }

}


